var InvoiceDocumentType;
(function (InvoiceDocumentType) {
  InvoiceDocumentType["Invoice"] = "Invoice";
  InvoiceDocumentType["Reminder"] = "Reminder";
  InvoiceDocumentType["CreditNote"] = "CreditNote";
})(InvoiceDocumentType || (InvoiceDocumentType = {}));
export default InvoiceDocumentType;